import { I18N_COOKIE_KEY } from "@/config/web-config";
import Cookies from "js-cookie";

export const SUPPORTED_LOCALES = ['en', 'es', 'pl'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const isSupportedLocale = (locale: unknown): locale is SupportedLocale => {
  return typeof locale === 'string' && SUPPORTED_LOCALES.includes(locale as SupportedLocale);
};

const getLocaleFromUrl = (): SupportedLocale | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const locale = new URLSearchParams(window.location.search).get('lang');
  return isSupportedLocale(locale) ? locale : undefined;
};

export const getDefaultLang = (): SupportedLocale => {
  const urlLocale = getLocaleFromUrl();
  if (urlLocale) {
    return urlLocale;
  }

  const storedLocale = Cookies.get(I18N_COOKIE_KEY);
  if (isSupportedLocale(storedLocale)) {
    return storedLocale;
  }

  if (typeof navigator !== 'undefined' && navigator.language) {
    const browserLanguage = navigator.language.split('-')[0];
    if (isSupportedLocale(browserLanguage)) {
      return browserLanguage;
    }
  }

  return 'en';
};
